var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurgeryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.475,
    height: 20,
    viewBox: "0 0 13.475 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surgical_sterilization",
    transform: "translate(-11.05 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M23.093,20.324A2,2,0,1,0,24,22.015l.112-2.009h.777L25,22.015a2,2,0,1,0,.907-1.691L25,4l-.5.028L24,4Zm1.74-1.318L24.5,13.028l-.333,5.978ZM25,11.018a.5.5,0,1,1-.5-.5A.5.5,0,0,1,25,11.018ZM21,22a1,1,0,1,1,1,1A1,1,0,0,1,21,22Zm6-1a1,1,0,1,0,1,1A1,1,0,0,0,27,21Z",
    transform: "translate(-4.475)",
    fill: "#9c8eeb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M13.025,9.5V4s-1.739,1.13-1.974,5.5a.961.961,0,0,0,.974,1A1,1,0,0,0,13.025,9.5Z",
    fill: "#9c8eeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M12,19.75a.75.75,0,0,1,1.5,0v.043l-1.5,1.5Z",
    transform: "translate(-0.475 -7.5)",
    fill: "#9c8eeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M12,24.914v.836l1.5-1.5v-.836Z",
    transform: "translate(-0.475 -9.707)",
    fill: "#9c8eeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M12,30.25v-.836l1.5-1.5v.836Z",
    transform: "translate(-0.475 -11.957)",
    fill: "#9c8eeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M12,33.914v3.543a.75.75,0,0,0,1.5,0V32.414Z",
    transform: "translate(-0.475 -14.207)",
    fill: "#9c8eeb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgeryIcon);
export default __webpack_public_path__ + "static/media/surgery-icon.b8395389294913c0824e18fc07455516.svg";
export { ForwardRef as ReactComponent };